export const IconIcon = () => {
    return (
        <svg
            width={18}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-white"
        >
            <path d="M14.75 0A3.25 3.25 0 0 1 18 3.25v6.879a2.25 2.25 0 0 1-.659 1.59l-5.621 5.622a2.249 2.249 0 0 1-1.591.659H3.25A3.25 3.25 0 0 1 0 14.75V3.25A3.25 3.25 0 0 1 3.25 0h11.5Zm0 1.5H3.25A1.75 1.75 0 0 0 1.5 3.25v11.5c0 .966.784 1.75 1.75 1.75H10v-3.064a6.658 6.658 0 0 1-.673.066L9 13.51a6.334 6.334 0 0 1-3.678-1.14.75.75 0 1 1 .854-1.234c.845.584 1.78.874 2.824.874.462 0 .903-.057 1.324-.171a3.247 3.247 0 0 1 2.713-1.832L13.25 10h3.25V3.25a1.75 1.75 0 0 0-1.75-1.75Zm.689 10h-2.188a1.75 1.75 0 0 0-1.744 1.607l-.006.143-.001 2.189 3.939-3.939ZM6 4.751A1.25 1.25 0 1 1 6 7.25a1.25 1.25 0 0 1 0-2.5v.001Zm6 0a1.25 1.25 0 1 1 .07 2.499A1.25 1.25 0 0 1 12 4.75Z" />
        </svg>
    );
};
